module.exports = __webpack_public_path__ + "img/UserSettings.660a21f4.svg";